export const closeAllChildElements = () => {
  document.querySelectorAll(`.profile_button`)?.forEach((childElement) => childElement.classList.remove("isShown"));
};
